import(/* webpackMode: "eager", webpackExports: ["Top"] */ "/codebuild/output/src4271355797/src/components/top.tsx");
